import { useQuery } from 'data-fetching-client';
import { GET_SURVEY_MONKEY_SURVEYS } from 'flow-doctor-lib/queries/SurveyMonkeyQueries';
const useSurveyMonkeySurvey = ({
  portalId,
  surveyId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_SURVEY_MONKEY_SURVEYS, {
    variables: {
      portalId
    }
  });
  const dataToReturn = data ? data.surveyMonkeySurveys.find(wrapper => wrapper.survey.surveyId === surveyId) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useSurveyMonkeySurvey;